export const PLAN_TIERS = [
  {
    id: 'free' as const,
    name: 'Free',
    monthlyPrice: 0,
    annualPrice: 0,
    included: 10_000,
    contacts: 10_000,
    overage: 0,
    features: [
      '10,000 emails/month',
      '1,000/day limit',
      '1 domain',
      'API + SMTP',
      '3-day analytics',
      'Community support',
    ],
  },
  {
    id: 'starter' as const,
    name: 'Starter',
    monthlyPrice: 5,
    annualPrice: 48,
    included: 25_000,
    contacts: 25_000,
    overage: 0.0004,
    features: [
      '25,000 emails/month',
      '2 domains',
      'API + SMTP',
      'Auto suppression',
      '7-day analytics',
      '2 webhooks',
    ],
  },
  {
    id: 'pro' as const,
    name: 'Pro',
    monthlyPrice: 18,
    annualPrice: 180,
    included: 75_000,
    contacts: 75_000,
    overage: 0.0003,
    popular: true,
    features: [
      '75,000 emails/month',
      '10 domains',
      'Priority queue',
      'Slack alerts',
      '30-day analytics',
      '3 team members',
    ],
  },
  {
    id: 'growth' as const,
    name: 'Growth',
    monthlyPrice: 45,
    annualPrice: 432,
    included: 300_000,
    contacts: 300_000,
    overage: 0.0002,
    features: [
      '300,000 emails/month',
      '25 domains',
      'Dedicated IP add-on',
      'Auto IP warming',
      '90-day analytics',
      '10 team members',
    ],
  },
  {
    id: 'scale' as const,
    name: 'Scale',
    monthlyPrice: 349,
    annualPrice: 3_492,
    included: 2_000_000,
    contacts: 2_000_000,
    overage: 0.0001,
    features: [
      '2,000,000 emails/month',
      'Unlimited domains',
      'Dedicated IP add-on',
      'Auto IP warming',
      '1-year analytics',
      'Slack support',
    ],
  },
] as const

export const MARKETING_PLAN_TIERS = [
  {
    id: 'free' as const,
    name: 'Free',
    monthlyPrice: 0,
    annualPrice: 0,
    included: 3_000,
    contacts: 3_000,
    features: [
      '3,000 emails/month',
      '500/day limit',
      '1 audience list',
      '3,000 contacts',
      '3-day analytics',
      'Community support',
    ],
  },
  {
    id: 'starter' as const,
    name: 'Starter',
    monthlyPrice: 15,
    annualPrice: 144,
    included: 10_000,
    contacts: 10_000,
    features: [
      '10,000 emails/month',
      '3 audience lists',
      'Drag-and-drop editor',
      '10,000 contacts',
      '7-day analytics',
      'A/B subject lines',
    ],
  },
  {
    id: 'pro' as const,
    name: 'Pro',
    monthlyPrice: 59,
    annualPrice: 588,
    included: 50_000,
    contacts: 50_000,
    popular: true,
    features: [
      '50,000 emails/month',
      '10 audience lists',
      'Custom templates',
      '50,000 contacts',
      '30-day analytics',
      'Automation flows',
    ],
  },
  {
    id: 'growth' as const,
    name: 'Growth',
    monthlyPrice: 149,
    annualPrice: 1_488,
    included: 150_000,
    contacts: 150_000,
    features: [
      '150,000 emails/month',
      '25 audience lists',
      'Dynamic content',
      '150,000 contacts',
      '90-day analytics',
      'Multi-step automations',
    ],
  },
  {
    id: 'scale' as const,
    name: 'Scale',
    monthlyPrice: 399,
    annualPrice: 3_984,
    included: 500_000,
    contacts: 500_000,
    features: [
      '500,000 emails/month',
      'Unlimited audience lists',
      'Dedicated IP add-on',
      '500,000 contacts',
      '1-year analytics',
      'Slack support',
    ],
  },
] as const

export const STATUS_COLORS = {
  queued: 'bg-gray-100 text-gray-700',
  sent: 'bg-blue-100 text-blue-700',
  delivered: 'bg-green-100 text-green-700',
  bounced: 'bg-red-100 text-red-700',
  complained: 'bg-orange-100 text-orange-700',
  rejected: 'bg-red-100 text-red-700',
  opened: 'bg-emerald-100 text-emerald-700',
  clicked: 'bg-cyan-100 text-cyan-700',
  active: 'bg-green-100 text-green-700',
  pending: 'bg-yellow-100 text-yellow-700',
  failed: 'bg-red-100 text-red-700',
  suspended: 'bg-gray-100 text-gray-700',
  smtp_engine: 'bg-brand-100 text-brand-700',
  ses: 'bg-amber-100 text-amber-700',
  mock: 'bg-gray-100 text-gray-700',
  // Suppression reasons
  hard_bounce: 'bg-red-100 text-red-700',
  complaint: 'bg-orange-100 text-orange-700',
  manual: 'bg-gray-100 text-gray-700',
  // API key scopes/types
  send: 'bg-blue-100 text-blue-700',
  full: 'bg-purple-100 text-purple-700',
  live: 'bg-green-100 text-green-700',
  test: 'bg-yellow-100 text-yellow-700',
  // IP warming statuses
  warming: 'bg-orange-100 text-orange-700',
  paused: 'bg-yellow-100 text-yellow-700',
  warm: 'bg-green-100 text-green-700',
  idle: 'bg-gray-100 text-gray-700',
  not_started: 'bg-gray-100 text-gray-700',
  // Newsletter / campaign statuses
  draft: 'bg-gray-100 text-gray-700',
  scheduled: 'bg-purple-100 text-purple-700',
  sending: 'bg-blue-100 text-blue-700',
  cancelled: 'bg-gray-100 text-gray-700',
  unsubscribed: 'bg-orange-100 text-orange-700',
  cleaned: 'bg-gray-100 text-gray-700',
  skipped: 'bg-yellow-100 text-yellow-700',
  // Generic quality indicators
  good: 'bg-green-100 text-green-700',
  warning: 'bg-yellow-100 text-yellow-700',
  bad: 'bg-red-100 text-red-700',
} as const

export const CONTACT_STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  unsubscribed: 'Unsubscribed',
  bounced: 'Bounced',
  cleaned: 'Cleaned',
  pending: 'Pending',
}

export const CONTACT_STATUS_COLORS: Record<string, string> = {
  active: 'bg-green-100 text-green-700',
  unsubscribed: 'bg-orange-100 text-orange-700',
  bounced: 'bg-red-100 text-red-700',
  cleaned: 'bg-gray-100 text-gray-700',
  pending: 'bg-yellow-100 text-yellow-700',
}
